<script>
import { mapGetters } from 'vuex'
import { getUsers } from '@/api/assetwise'

export default {
  props: {
    teams: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => typeof item === 'string')
    },
    type: {
      type: String,
      default: 'all',
      validator: (value) => ['all', 'broker', 'executive'].includes(value)
    },
    textType: {
      type: String,
      default: 'broker',
      validator: (value) => ['broker', 'executive'].includes(value)
    }
  },
  data() {
    return {
      items: [{ value: '', text: this.$t('All') }],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    teams() {
      this.fetchItems()
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const items = await getUsers({
          page_id: this.selectedBot.pageid,
          limit: Number.MAX_SAFE_INTEGER,
          offset: 0,
          team_name: this.teams,
          type: this.type
        }).then((response) => {
          const { data = [] } = response.data
          return data
        })

        this.items = [
          { value: '', text: this.$t('All') },
          ...items.map((item) => ({
            value: item.user_id,
            text: (() => {
              const name =
                item[
                  {
                    broker: 'broker_name',
                    executive: 'executive_name'
                  }[this.textType]
                ]
              if (!name) return item.social_name
              return `${name} (${item.social_name})`
            })()
          }))
        ]
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      options: this.items,
      loading: this.isLoading
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/providers/UserOptionListProvider.vue